import request from "../utils/request-axios";
import api from "../utils/api";

//获取banner图分页
export function getBannerPage(params) {
  return request(`${api.getBannerPage}`, {
    loading: true,
    method: 'get',
    data: params,
  })
}

//根据id获取详情
export function getBannerId(params) {
  return request(`${api.getBannerId}${params}`, {
    loading: true,
    method: 'get',
  })
}

//添加banner图
export function addBanner(params) {
  return request(`${api.addBanner}`, {
    loading: true,
    method: 'post',
    data: params,
    promptMessage: "添加成功!",
  })
}

//编辑banner图
export function editBanner(params) {
  return request(`${api.editBanner}`, {
    loading: true,
    method: 'put',
    data: params,
    promptMessage: "编辑成功!",
  })
}

//删除banner图
export function deleteBanner(params) {
  return request(`${api.deleteBanner}${params}`, {
    loading: true,
    method: 'delete',
    promptMessage: "删除成功!",
  })
}



// WEBPACK FOOTER //
// ./src/services/banner.js